var ko = require('knockout'),
  dateUtil = require('_utils/date'),
  APIHelper = require('_js/APIHelper'),
  HOURS_TYPE = require('_js/constants/hours'),
  cloneDeep = require('lodash/cloneDeep'),
  decodeHtml = require('_utils/text');

// Amount specified in days.
var SOON_EXPIRATION_THRESHOLD = 14;

function GetCourseType(courseType) {
  switch (courseType) {
    case 3:
    case 7:
    case 8:
      return 'icon-screen';
    case 6:
      return 'icon-program';
    default:
      return 'icon-calendar';
  }
}

function MapDiplomaUrlAndLabels(
  registrationKey,
  courseDiplomaBaseUrl,
  programRegistrationKeyYearPairs
) {
  if (
    programRegistrationKeyYearPairs &&
    programRegistrationKeyYearPairs.length > 1
  ) {
    return programRegistrationKeyYearPairs.map(function(pair) {
      return {
        url: courseDiplomaBaseUrl + '/' + pair.Item1,
        label: window.language.courses.diploma + ' ' + pair.Item2
      };
    });
  }

  return [
    {
      url: courseDiplomaBaseUrl + '/' + registrationKey,
      label: window.language.courses.diploma
    }
  ];
}

function CoursesListItem(params) {
  this.isHistorical = ko.observable(params.isHistorical);
  this.isExpanded = ko.observable(false);
  this.API = params.api;
  this.texts = params.texts;
  this.helpPageReferenceLink = params.links.helpPageReference;
  this.helpPageReferenceText = params.texts.helpPageReferenceText;
  this.questionAboutCourseCompletionText =
    params.texts.questionAboutCourseCompletionText;
  this.termsAndConditionsLink = params.links.termsAndConditionsPageReference;
  this.termsAndConditionsText =
    params.texts.termsAndConditionsPageReferenceText;
  this.expirationViewDate = dateUtil.convertDateToNorwegianStyleString(
    params.data.ExpirationViewDate
  );
  this.documentation = params.data.Documentation;
  this.course = params.data.Course;
  this.courseUrl = params.data.Url;
  this.isNetCourse = params.data.Course.IsNetCourse;
  this.isProgram = params.data.Course.EventType === 6;
  this.isProgramOnline = params.data.Course.EventType === 7;
  this.programDateString = params.data.ProgramDateString;
  this.eventType = GetCourseType(params.data.Course.EventType);
  this.aboutText = this.isProgram
    ? window.language.courses.aboutProgram
    : window.language.courses.aboutCourse;
  this.descriptionLinkText = this.isProgram
    ? window.language.courses.programDescription
    : window.language.courses.courseDescription;
  this.isComplete = params.data.IsComplete;
  this.packageName = params.data.PackageName;
  // Get timedifference in days
  var timeDiff =
    (new Date(params.data.ExpirationViewDate).getTime() -
      new Date().getTime()) /
    (1000 * 3600 * 24);
  this.soonToExpire =
    this.isNetCourse &&
    !this.isComplete &&
    timeDiff < SOON_EXPIRATION_THRESHOLD;
  var today = new Date();
  today.setHours(0, 0, 0);
  var expirationDateMidnight = new Date(params.data.ExpirationDate);
  expirationDateMidnight.setHours(0, 0, 0);
  this.expired = expirationDateMidnight.getTime() < today.getTime();
  this.isClosedForCancellation = params.data.IsClosedForCancellation;
  this.isOnWaitingList = params.data.IsOnWaitingList;
  this.completedDate = dateUtil.convertDateToNorwegianStyleString(
    params.data.CompletedDate
  );
  this.index = params.index;
  this.isModalActive = params.isModalActive;
  this.setActiveCourse = params.setActiveCourse;
  this.hoursType = this.isHistorical() ? HOURS_TYPE.DONE : HOURS_TYPE.PLANNED;

  this.indexInCourses = params.indexInCourses;
  this.indexInOrganizers = params.indexInOrganizers;
  this.selectedOrganizer = params.selectedOrganizer;
  this.parent = params.parent;
  this.courseDate = params.data.CourseFromDateString;

  this.registrationKey = params.data.RegistrationKey;
  this.diplomas = MapDiplomaUrlAndLabels(
    this.registrationKey,
    this.API.courseDiplomaUrl,
    params.data.ProgramRegistrationKeyYearPairs
  );
  this.title = ko.observable(this.course.CourseTitle);
  this.organizer = ko.observable(this.course.Organizer);
  this.fromDate = ko.observable(this.course.FromDate);
  this.website = ko.computed(
    function() {
      if (this.course.WebSite === null || this.course.WebSite.length === 0) {
        return '';
      } else if (this.course.WebSite.indexOf('http') !== -1) {
        return this.course.WebSite;
      } else {
        return 'http://' + this.course.WebSite;
      }
    }.bind(this)
  );

  this.categories = ko.observableArray(
    ko.utils.arrayMap(this.course.ActiveAuthorizationCredits, function(
      category
    ) {
      var tmpCategory = cloneDeep(category);
      tmpCategory.Hours = ko.observable(tmpCategory.Hours);
      return tmpCategory;
    })
  );
  // Need to create an object in the format the calculator-external-course component expects.
  this.preAnswers = {
    title: this.course.CourseTitle,
    organizer: this.course.Organizer,
    fromDate: this.courseDate,
    sequencePk: this.course.SequencePK,
    categories: this.course.AuthorizationCredits,
    isSelfStudy: this.course.IsSelfStudy
  };
  this.courseType = '';
}

CoursesListItem.prototype.init = function(element) {
  this.$element = $(element);
};

CoursesListItem.prototype.deleteCourse = function() {
  this.$element.slideUp(250, 'easeOutQuad');
};

CoursesListItem.prototype.cancelCourse = function() {
  this.setActiveCourse(this.index);
  this.isModalActive(true);
};

CoursesListItem.prototype.expandItemDetails = function() {
  this.isExpanded(!this.isExpanded());
};

CoursesListItem.prototype.updateCourseValues = function(params) {
  this.title(decodeHtml(params.title));
  this.organizer(decodeHtml(params.organizer));
  this.fromDate(params.fromDate);

  this.categories(
    ko.utils.arrayMap(params.categories, function(category) {
      var tmpCategory = cloneDeep(category);
      tmpCategory.Hours = ko.observable(tmpCategory.Hours);
      return tmpCategory;
    })
  );
  this.categories.valueHasMutated();

  var updatedCourse = {
    title: this.title(),
    organizer: this.organizer(),
    fromDate: this.fromDate(),
    categories: this.categories()
  };

  if (this.parent.modifySpecificCourse) {
    this.parent.modifySpecificCourse(
      this.indexInCourses,
      this.indexInOrganizers,
      this.selectedOrganizer,
      updatedCourse
    );
  }
};

CoursesListItem.prototype.startMultimediaCourse = function() {
  var url =
    this.API.getLaunchLinkMultimediaCourseUrl +
    '?registrationId=' +
    encodeURIComponent(this.registrationKey);

  APIHelper.get(
    url,
    function(launchLink) {
      window.location.href = launchLink;
    },
    function() {
      /* eslint-disable no-console */
      console.error(
        'Something went wrong when fetching launch link for multimedia course'
      );
    }
  );
};

CoursesListItem.prototype.startCourse = function() {
  if(this.isNetCourse){
    window.location.href =
      this.API.brightCoveNetCourseUrl +
      '?courseSequenceId=' +
      this.course.SequenceId;
  }
  return null;
};

module.exports = CoursesListItem;
